import React, { useReducer } from 'react';
import LocalidadContext from './localidadContext';
import LocalidadReducer from './localidadReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_LOCALIDADES,
    AGREGAR_LOCALIDAD,
    ELIMINAR_LOCALIDAD,
    ACTUALIZAR_LOCALIDAD,
    LOCALIDAD_ERROR,
    LOCALIDAD_OK,
    LOCALIDAD_ACTUAL,
    OBTENER_LOCALIDAD,
    LIMPIAR_LOCALIDADES
} from 'types/context';

const LocalidadState = props => {
    const initialState = {
        localidades : [], // localidades de la prov
        localidad: null,
        provincia: null,
        formulario : false,
        errorformulario: false,        
        mensaje: null
    }

    const [ state, dispatch ] = useReducer(LocalidadReducer, initialState);

    // Obtener las localidades
    const obtenerLocalidades = async (provinciaId) => {
        let tamanio={tamanio:1000};
        try {
            // siempre deberia venir una provincia
            let resultado;
            
            if(provinciaId){
                resultado = await clienteAxios.get(`/localidades?provincia=${provinciaId}`, {params:tamanio});
            }else{
                resultado = await clienteAxios.get('/localidades',{params:tamanio});
            }
            
            //console.log(resultado);
            dispatch({
                type: OBTENER_LOCALIDADES,
                payload: resultado.data.localidades
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: LOCALIDAD_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nueva localidad
    const agregarLocalidad = async localidad => {

        try {
            const resultado = await clienteAxios.post('/localidades', localidad);
            //console.log(resultado);
            // Insertar la prov en el state
            dispatch({
                type: AGREGAR_LOCALIDAD,
                payload: resultado.data.localidad
            })
            const alerta = {
                msg: "Localidad creada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: LOCALIDAD_OK,
                payload: alerta
            })
            return resultado.data
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOCALIDAD_ERROR,
                payload: alerta
            })
        }
    }
    // Selecciona la Localidad que el usuario dio click
    const localidadActual = localidadId => {
        dispatch({
            type: LOCALIDAD_ACTUAL,
            payload: localidadId
        })
    }

    // Elimina una Localidad
    const eliminarLocalidad = async localidadId => {
        try {
            await clienteAxios.delete(`/localidades/${localidadId}`);
            dispatch({
                type: ELIMINAR_LOCALIDAD,
                payload: localidadId
            })
            const alerta = {
                msg: "Localidad eliminada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: LOCALIDAD_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOCALIDAD_ERROR,
                payload: alerta
            })
        }
    }

    // Aactualizar localidad
    const actualizarLocalidad = async localidad => {

        try {
            const resultado = await  clienteAxios.put(`/localidades/${localidad.id}`, localidad);
            //console.log(resultado);
            // Actualizo la loc en el state
            dispatch({
                type: ACTUALIZAR_LOCALIDAD,
                payload: resultado.data.localidad
            })
            const alerta = {
                msg: "Localidad actualizada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: LOCALIDAD_OK,
                payload: alerta
            })
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: LOCALIDAD_ERROR,
                payload: alerta
            })
        }
    }

    // muestra un error de validacion
    const errorLocalidad = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: LOCALIDAD_ERROR,
            payload: alerta
        })
    }

    // Obtengo una localidad por id
    const obtenerLocalidad = async (localidadId) => {
        try {
            
            const resultado = await clienteAxios.get(`/localidades?id=${localidadId}`);                   
           
            dispatch({
                type: OBTENER_LOCALIDAD,
                payload: resultado.data.localidades
            })
            return resultado.data.localidades;            
            
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: LOCALIDAD_ERROR,
                payload: alerta
            })
        }
    }
    const OkLocalidad = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: LOCALIDAD_OK,
            payload: alerta
        })
    }
    const clearErrorLocalidad = () => {
        dispatch({
            type: LOCALIDAD_ERROR,
            payload: null,
        });
        };

    const clearOkLocalidad = () => {
        dispatch({
            type: LOCALIDAD_OK,
            payload: null,
        });
    }
    const limpiarLocalidad = () =>{
        dispatch({
            type: LIMPIAR_LOCALIDADES,
            payload: null
        })
    }
    return(
        <LocalidadContext.Provider
            value={{
                localidades: state.localidades,
                localidad: state.localidad,
                provincia: state.provincia,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                obtenerLocalidades,
                limpiarLocalidad,
                agregarLocalidad,
                localidadActual,
                eliminarLocalidad,
                actualizarLocalidad,
                errorLocalidad,
                obtenerLocalidad,
                OkLocalidad,
                clearOkLocalidad,
                clearErrorLocalidad
            }}
        >{props.children}

        </LocalidadContext.Provider>
    )
}
export default LocalidadState;
